import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";

const BarLabel = ({ x, y, value, width, height }) => (
  <text
    x={x + width - 5}
    y={y}
    dy={height / 2 + 5}
    fill="#fff"
    fontSize={14}
    textAnchor="end"
  >
    {Intl.NumberFormat("de-DE", { maximumFractionDigits: 2 }).format(value)}
  </text>
);

const HorizontalBarChart = ({ chartData }) => (
  <ResponsiveContainer aspect={2.0} minHeight={1} width="100%">
    <BarChart
      data={chartData}
      margin={{
        top: 10,
        right: 30,
        left: 0,
        bottom: 0,
      }}
      layout="vertical"
    >
      <XAxis type="number" interval="preserveStartEnd" />
      <YAxis
        type="category"
        dataKey="region"
        tick={{ fontSize: 10 }}
        width={180}
      />
      <CartesianGrid strokeDasharray="3 3" />
      <Bar dataKey="value" fill="#1b66b3" label={<BarLabel />} />
    </BarChart>
  </ResponsiveContainer>
);

export default HorizontalBarChart;
